import React from 'react';

import { Typography, Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.25rem',
    marginBottom: '6.25rem'
  },
  mainCont: {
    width: '51%',
    padding: '2rem 0',
    borderTop: '1px solid #9C9C9C',
    borderBottom: '1px solid #9C9C9C',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  noteCont: {
    width: '100%',
    marginBottom: '1rem'
  },
  footNoteText: {
    ...theme.extraFonts.footNote,
    // margin: '1rem 0',
    wordWrap: 'break-word',
    width: '90%',
    marginBottom: '1rem'
  },
  sup: {
    width: '40px',
    marginRight: '1rem',
    color: theme.palette.common.lightGrey
  },
  link: {
    color: theme.palette.common.lightGrey,
    textDecoration: 'none'
  },
  title: {
    color: theme.palette.common.lightGrey,
    fontFamily: 'proximaNovaReg'
  },
  textCont: {
    width: '90%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}));

const footerData = [
  {
    sup: '1+6',
    title: 'U.S. Department of Health and Human Services',
    note: 'https://minorityhealth.hhs.gov/omh/browse.aspx?lvl=4&lvlid=16'
  },
  {
    sup: '2',
    title: 'U.S. Department of Health and Human Services',
    note:
      'https://minorityhealth.hhs.gov/omh/browse.aspx?lvl=4&lvlid=61#:~:text=Hispanic%20women%20are%2040%20percent,to%20non%2DHispanic%20white%20women'
  },

  // {
  //   sup: '3 ',
  //   note: '',
  //   title:
  //     'The information provided is not intended to substitute for medical advice. Always consult your doctor in health related matters.'
  // },
  {
    sup: '3 ',
    title: 'Biological Research',
    note: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5625777/'
  },
  {
    sup: '4 ',
    title: 'Oncotarget',
    note: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5352107/'
  },
  {
    sup: '5',
    title: 'Nature Reviews Cancer',
    note: 'https://www.nature.com/articles/nrc3896'
  },
  {
    sup: '7 ',
    title: 'CDC',
    note:
      'https://www.cdc.gov/mmwr/volumes/65/wr/mm6540a1.htm?CDC_AA_refVal=https%3A%2F%2Fwww.cdc.gov%2Fcancer%2Fdcpc%2Fresearch%2Farticles%2Fbreast_cancer_rates_women.htm'
  },
  {
    sup: '8 ',
    title: 'Contemporary OB/GYN',
    note:
      'https://www.contemporaryobgyn.net/view/addressing-the-cervical-cancer-screening-disparities-gap'
  },
  {
    sup: '9 ',
    title: ' Human Papilloma Virus-Associated Cervical Cancer and Health Disparities',
    note: ' https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6628030/'
  },
  {
    sup: '10+11+14 ',
    title: ' Health and Racial Disparity in Breast Cancer',
    note: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6941147/'
  },
  {
    sup: '12 ',
    title: 'Journal of the American College of Radiology',
    note: 'https://www.jacr.org/article/S1546-1440(21)00006-5/fulltext'
  },
  {
    sup: '13 ',
    title: 'JAMA Network',
    note: 'https://jamanetwork.com/journals/jamaoncology/fullarticle/2758266'
  },
  {
    sup: '15 ',
    title: 'National Partnership for Women & Families',
    note:
      'https://www.nationalpartnership.org/our-work/resources/health-care/latinas-health-insurance-coverage.pdf'
  },
  {
    sup: '16 ',
    title: ' American Cancer Society',
    note:
      'https://www.cancer.org/content/dam/cancer-org/research/cancer-facts-and-statistics/cancer-facts-and-figures-for-african-americans/cancer-facts-and-figures-for-african-americans-2019-2021.pdf'
  },
  {
    sup: '17 ',
    title: ' Medical Care',
    note: 'https://www.jstor.org/stable/3768379?seq=1'
  }
];

const Footnotes = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Grid container direction="column" alignItems="center" className={classes.wrapper}>
      <Grid container className={classes.mainCont}>
        {footerData.map((note) => (
          <Grid
            container
            item
            direction={matchesSM ? 'column' : 'row'}
            key={note.sup}
            className={classes.noteCont}
          >
            <Grid container style={{ width: '10%' }}>
              <Typography className={classes.sup}>
                <sup>{note.sup}</sup>
              </Typography>
            </Grid>
            <Grid container className={classes.textCont}>
              <a href={note.note} className={classes.link}>
                {' '}
                <Typography className={classes.title}>{note.title}</Typography>
              </a>
              {/* <Typography className={classes.footNoteText}>
                <a href={note.note} className={classes.link}>
                  {note.note}
                </a>
              </Typography> */}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default Footnotes;
